import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { PhxTextEntityNode } from '../../nodes/PhxTextEntityNode';

interface TextEntitiesPluginProps {
  manualId?: string;
}

/**
 * TextEntitiesPlugin validates that PhxTextEntityNode is registered on the editor.
 * Text entities are inserted via the InsertTextEntityDialog modal only.
 * Text entities cannot be edited - they can only be deleted.
 */
export default function TextEntitiesPlugin({ manualId }: TextEntitiesPluginProps): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([PhxTextEntityNode])) {
      throw new Error('TextEntitiesPlugin: TextEntityNode is not registered on editor');
    }
  }, [editor]);

  // Plugin doesn't render anything - it only validates node registration
  return null;
}
